module.exports = __webpack_public_path__ + "static/media/menorah.63d4088c.svg";